// import React, { useState, useEffect, useRef } from 'react';
// import { Container, Nav, Navbar, Button, Modal } from 'react-bootstrap';
// import { Link, useNavigate, useLocation } from 'react-router-dom';
// import {
//   FaUser,
//   FaPalette,
//   FaStore,
//   FaExchangeAlt,
//   FaChevronDown,
//   FaBars,
//   FaLock,
//   FaUnlockAlt,
//   FaCheckCircle,
//   FaSpinner,
//   FaArrowLeft,
// } from 'react-icons/fa';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import Logo from '../../assets/logo7.png';
// import MpesaLogo from '../../assets/mpesa-logo.png';
// import '../../styles/nav.scss';
// import { toast } from 'react-toastify';
// import { serverUrlAuth } from '../../serverUrl';

// export default function FurnitureNavbar() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [user, setUser] = useState(null);
//   const [currentMode, setCurrentMode] = useState('custom');
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);
//   const [showUpgradeModal, setShowUpgradeModal] = useState(false);
//   const [artisanHasShopAccess, setArtisanHasShopAccess] = useState(false);

//   // Payment states
//   const [paymentStep, setPaymentStep] = useState('info'); // info, mpesa, processing, success
//   const [mpesaPhone, setMpesaPhone] = useState('');
//   const [processingPayment, setProcessingPayment] = useState(false);
//   const [checkoutRequestId, setCheckoutRequestId] = useState(null);
//   const [paymentInterval, setPaymentInterval] = useState(null);

//   const dropdownRef = useRef(null);

//   // Load user info and check payment status for artisans
//   useEffect(() => {
//     const token = localStorage.getItem('access_token');
//     const role = localStorage.getItem('role');
//     const fullName = localStorage.getItem('full_name');
//     const savedMode = localStorage.getItem('user_mode') || 'custom';

//     if (token && role) {
//       setUser({ role, name: fullName });
//       setCurrentMode(savedMode);

//       if (role === 'artisan') {
//         // Check payment status from backend
//         serverUrlAuth
//           .get('users/ready-products-payment-status/')
//           .then((res) => {
//             if (res.data.has_paid_ready_products) {
//               setArtisanHasShopAccess(true);
//               localStorage.setItem('artisan_shop_access', 'true');
//             } else {
//               setArtisanHasShopAccess(false);
//             }
//           })
//           .catch((err) =>
//             console.error('Failed to check payment status:', err),
//           );
//       }
//     }
//   }, [location.pathname]);

//   // Detect current mode based on URL path
//   useEffect(() => {
//     if (
//       location.pathname.includes('/artisan-dashboard') ||
//       location.pathname.includes('/browse-project-requests') ||
//       location.pathname.includes('/my-proposals') ||
//       location.pathname.includes('/artisan-profile') ||
//       location.pathname.includes('/my-projects') ||
//       location.pathname.includes('/messaging')
//     ) {
//       setCurrentMode('custom');
//     } else if (
//       location.pathname.includes('/artisan-ready-products') ||
//       location.pathname.includes('/artisan-product-management') ||
//       location.pathname.includes('/artisan-orders') ||
//       location.pathname.includes('/artisan-earnings')
//     ) {
//       setCurrentMode('shop');
//     }
//   }, [location.pathname]);

//   // Handle scroll effect
//   useEffect(() => {
//     const handleScroll = () => setScrolled(window.scrollY > 20);
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
//         setDropdownOpen(false);
//       }
//     };
//     document.addEventListener('click', handleClickOutside);
//     return () => document.removeEventListener('click', handleClickOutside);
//   }, []);

//   // Cleanup payment interval
//   useEffect(() => {
//     return () => {
//       if (paymentInterval) clearInterval(paymentInterval);
//     };
//   }, [paymentInterval]);

//   // Client mode switching
//   const handleClientSwitch = () => {
//     const newMode = currentMode === 'custom' ? 'shop' : 'custom';
//     localStorage.setItem('user_mode', newMode);
//     setCurrentMode(newMode);

//     if (newMode === 'custom') {
//       navigate('/client-dashboard');
//       toast.info('Switched to Custom Orders');
//     } else {
//       navigate('/ready-made-products');
//       toast.info('Switched to Ready-Made Products');
//     }
//   };

//   // Artisan mode switching
//   const handleArtisanSwitch = () => {
//     if (!artisanHasShopAccess && currentMode === 'custom') {
//       setShowUpgradeModal(true);
//       return;
//     }

//     const newMode = currentMode === 'custom' ? 'shop' : 'custom';
//     localStorage.setItem('user_mode', newMode);
//     setCurrentMode(newMode);

//     if (newMode === 'custom') {
//       navigate('/artisan-dashboard');
//       toast.info('Switched to Custom Projects');
//     } else {
//       navigate('/artisan-ready-products');
//       toast.info('Switched to Ready-Made Shop');
//     }
//   };

//   // M-Pesa Payment Handler
//   const handleMpesaPayment = async () => {
//     if (
//       !mpesaPhone ||
//       !/^(\+?\d{1,3}[-.]?)?\d{10}$/.test(mpesaPhone.replace(/\s/g, ''))
//     ) {
//       toast.error('Please enter a valid M-Pesa phone number');
//       return;
//     }

//     setProcessingPayment(true);
//     setPaymentStep('processing');

//     try {
//       const response = await serverUrlAuth.post('projects/mpesa/stk-push/', {
//         phone_number: mpesaPhone,
//         amount: 2900,
//         account_reference: `PREMIUM-${Date.now()}`,
//       });

//       setCheckoutRequestId(response.data.checkout_request_id);
//       toast.info('Please check your phone and enter your M-Pesa PIN');

//       const interval = setInterval(async () => {
//         try {
//           const statusResponse = await serverUrlAuth.get(
//             `projects/mpesa/check-status/${response.data.checkout_request_id}/`,
//           );

//           if (statusResponse.data.status === 'completed') {
//             clearInterval(interval);
//             setPaymentInterval(null);
//             await verifyPaymentAndUpgrade();
//           } else if (statusResponse.data.status === 'failed') {
//             clearInterval(interval);
//             setPaymentInterval(null);
//             setPaymentStep('info');
//             setProcessingPayment(false);
//             toast.error('Payment failed. Please try again.');
//           }
//         } catch (err) {
//           console.error('Error checking payment status:', err);
//         }
//       }, 3000);

//       setPaymentInterval(interval);

//       // Timeout after 2 minutes
//       setTimeout(() => {
//         if (paymentInterval) {
//           clearInterval(paymentInterval);
//           setPaymentInterval(null);
//           setPaymentStep('info');
//           setProcessingPayment(false);
//           toast.error('Payment timeout. Please try again.');
//         }
//       }, 120000);
//     } catch (err) {
//       console.error('Error initiating payment:', err);
//       toast.error(err.response?.data?.message || 'Failed to initiate payment');
//       setProcessingPayment(false);
//       setPaymentStep('info');
//     }
//   };

//   const verifyPaymentAndUpgrade = async () => {
//     try {
//       const verifyResponse = await serverUrlAuth.post(
//         'projects/verify-ready-products-payment/',
//         {
//           phone_number: mpesaPhone,
//           amount: 2900,
//           checkout_request_id: checkoutRequestId,
//         },
//       );

//       if (verifyResponse.data.success) {
//         localStorage.setItem('artisan_shop_access', 'true');
//         setArtisanHasShopAccess(true);
//         setPaymentStep('success');
//         setProcessingPayment(false);

//         toast.success('Payment successful! 🎉 Welcome to Premium!');

//         setTimeout(() => {
//           setShowUpgradeModal(false);
//           resetPaymentModal();
//           setCurrentMode('shop');
//           localStorage.setItem('user_mode', 'shop');
//           navigate('/artisan-ready-products');
//         }, 2000);
//       } else {
//         throw new Error('Verification failed');
//       }
//     } catch (err) {
//       console.error('Error verifying payment:', err);
//       toast.error('Payment verification failed. Please contact support.');
//       setPaymentStep('info');
//       setProcessingPayment(false);
//     }
//   };

//   const resetPaymentModal = () => {
//     setPaymentStep('info');
//     setMpesaPhone('');
//     setProcessingPayment(false);
//     setCheckoutRequestId(null);
//     if (paymentInterval) {
//       clearInterval(paymentInterval);
//       setPaymentInterval(null);
//     }
//   };

//   const handleCloseUpgradeModal = () => {
//     resetPaymentModal();
//     setShowUpgradeModal(false);
//   };

//   // Logout
//   const handleLogout = () => {
//     localStorage.clear();
//     setUser(null);
//     navigate('/login');
//     toast.success('Logout successful');
//     setDropdownOpen(false);
//   };

//   // ✅ Always show mode switch for logged-in artisans and clients
//   const shouldShowModeSwitch =
//     user && (user.role === 'client' || user.role === 'artisan');

//   const getArtisanSwitchButton = () => {
//     if (!artisanHasShopAccess && currentMode === 'custom') {
//       return {
//         icon: <FaLock className="me-2" />,
//         text: (
//           <>
//             <FaStore /> Shop{' '}
//             <FaLock className="ms-1" style={{ fontSize: '0.8rem' }} />
//           </>
//         ),
//         className: 'mode-switch-btn locked',
//       };
//     }

//     return {
//       icon: <FaExchangeAlt className="me-2" />,
//       text:
//         currentMode === 'custom' ? (
//           <>
//             Switch to <FaStore /> Shop
//           </>
//         ) : (
//           <>
//             Switch to <FaPalette /> Custom
//           </>
//         ),
//       className: 'mode-switch-btn',
//     };
//   };

//   const getClientSwitchButton = () => {
//     return {
//       icon: <FaExchangeAlt className="me-2" />,
//       text:
//         currentMode === 'custom' ? (
//           <>
//             Switch to <FaStore /> Shop
//           </>
//         ) : (
//           <>
//             Switch to <FaPalette /> Custom
//           </>
//         ),
//       className: 'mode-switch-btn',
//     };
//   };

//   return (
//     <>
//       <Navbar
//         expand="lg"
//         className={`furniture-navbar ${scrolled ? 'scrolled' : ''}`}
//         collapseOnSelect
//       >
//         <Container>
//           {/* Logo */}
//           <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
//             <img src={Logo} alt="Artiza logo" className="logo" />
//           </Navbar.Brand>

//           {/* Mobile Right Section */}
//           <div className="mobile-right-section d-flex d-lg-none align-items-center">
//             {shouldShowModeSwitch && user?.role === 'client' && (
//               <Button
//                 className="mode-switch-btn-mobile"
//                 onClick={handleClientSwitch}
//                 title={`Switch to ${currentMode === 'custom' ? 'Ready-Made Shop' : 'Custom Orders'}`}
//               >
//                 <FaExchangeAlt />
//               </Button>
//             )}
//             {shouldShowModeSwitch && user?.role === 'artisan' && (
//               <Button
//                 className={`mode-switch-btn-mobile ${!artisanHasShopAccess && currentMode === 'custom' ? 'locked' : ''}`}
//                 onClick={handleArtisanSwitch}
//               >
//                 {!artisanHasShopAccess && currentMode === 'custom' ? (
//                   <FaLock />
//                 ) : (
//                   <FaExchangeAlt />
//                 )}
//               </Button>
//             )}
//             <Navbar.Toggle aria-controls="basic-navbar-nav">
//               <FaBars />
//             </Navbar.Toggle>
//           </div>

//           <Navbar.Collapse id="basic-navbar-nav">
//             <Nav className="mx-auto nav-links">
//               {!user && (
//                 <>
//                   <Nav.Link as={Link} to="/">
//                     Home
//                   </Nav.Link>
//                   <Nav.Link as={Link} to="/about">
//                     About
//                   </Nav.Link>
//                   <Nav.Link as={Link} to="/contact">
//                     Contact
//                   </Nav.Link>
//                 </>
//               )}

//               {user?.role === 'client' && currentMode === 'custom' && (
//                 <>
//                   <Nav.Link as={Link} to="/client-dashboard">
//                     Dashboard
//                   </Nav.Link>
//                   <Nav.Link as={Link} to="/projects">
//                     My Projects
//                   </Nav.Link>
//                   <Nav.Link as={Link} to="/project-updates">
//                     Project Progress
//                   </Nav.Link>
//                   <Nav.Link as={Link} to="/messages">
//                     Messages
//                   </Nav.Link>
//                   <Nav.Link as={Link} to="/payments">
//                     Payments
//                   </Nav.Link>
//                   <Nav.Link as={Link} to="/Profile">
//                     Profile
//                   </Nav.Link>
//                 </>
//               )}

//               {user?.role === 'client' && currentMode === 'shop' && (
//                 <>
//                   <Nav.Link as={Link} to="/ready-made-products">
//                     Shop
//                   </Nav.Link>
//                   <Nav.Link as={Link} to="/cart">
//                     Cart
//                   </Nav.Link>
//                   <Nav.Link as={Link} to="/Profile">
//                     Profile
//                   </Nav.Link>
//                 </>
//               )}

//               {user?.role === 'artisan' && currentMode === 'custom' && (
//                 <>
//                   <Nav.Link as={Link} to="/artisan-dashboard">
//                     Dashboard
//                   </Nav.Link>
//                   <Nav.Link as={Link} to="/browse-project-requests">
//                     Browse Projects
//                   </Nav.Link>
//                   <Nav.Link as={Link} to="/messaging">
//                     Messages
//                   </Nav.Link>
//                   <Nav.Link as={Link} to="/my-projects">
//                     Project Updates
//                   </Nav.Link>
//                   <Nav.Link as={Link} to="/artisan-profile">
//                     Profile
//                   </Nav.Link>
//                 </>
//               )}

//               {user?.role === 'artisan' &&
//                 currentMode === 'shop' &&
//                 artisanHasShopAccess && (
//                   <>
//                     <Nav.Link as={Link} to="/artisan-ready-products">
//                       My Products
//                     </Nav.Link>
//                     <Nav.Link as={Link} to="/artisan-product-management">
//                       Add Product
//                     </Nav.Link>
//                     <Nav.Link as={Link} to="/artisan-orders">
//                       Orders
//                     </Nav.Link>
//                     <Nav.Link as={Link} to="/artisan-earnings">
//                       Earnings
//                     </Nav.Link>
//                     <Nav.Link as={Link} to="/artisan-profile">
//                       Profile
//                     </Nav.Link>
//                   </>
//                 )}

//               {user?.role === 'artisan' &&
//                 currentMode === 'shop' &&
//                 !artisanHasShopAccess && (
//                   <>
//                     <Nav.Link
//                       className="locked-link"
//                       onClick={() => setShowUpgradeModal(true)}
//                     >
//                       <FaLock className="me-1" /> My Products
//                     </Nav.Link>
//                     <Nav.Link
//                       className="locked-link"
//                       onClick={() => setShowUpgradeModal(true)}
//                     >
//                       <FaLock className="me-1" /> Add Product
//                     </Nav.Link>
//                     <Nav.Link
//                       className="locked-link"
//                       onClick={() => setShowUpgradeModal(true)}
//                     >
//                       <FaLock className="me-1" /> Orders
//                     </Nav.Link>
//                     <Nav.Link as={Link} to="/artisan-profile">
//                       Profile
//                     </Nav.Link>
//                   </>
//                 )}

//               {user?.role === 'admin' && (
//                 <>
//                   <Nav.Link as={Link} to="/admin-dashboard">
//                     Dashboard
//                   </Nav.Link>
//                   <Nav.Link as={Link} to="/users-management">
//                     Users
//                   </Nav.Link>
//                   <Nav.Link as={Link} to="/projects-management">
//                     Projects
//                   </Nav.Link>
//                   <Nav.Link as={Link} to="/flagged-messages">
//                     Flagged
//                   </Nav.Link>
//                   <Nav.Link as={Link} to="/artisan-applications">
//                     Artisan Applications
//                   </Nav.Link>
//                   <Nav.Link as={Link} to="/financials">
//                     Financials
//                   </Nav.Link>
//                   <Nav.Link as={Link} to="/support">
//                     Support
//                   </Nav.Link>
//                 </>
//               )}
//             </Nav>

//             {/* Desktop Actions - Mode Switch always visible for logged-in users */}
//             <div className="desktop-actions d-none d-lg-flex align-items-center">
//               {shouldShowModeSwitch && user?.role === 'client' && (
//                 <Button
//                   className={getClientSwitchButton().className}
//                   onClick={handleClientSwitch}
//                 >
//                   {getClientSwitchButton().icon}
//                   <span>{getClientSwitchButton().text}</span>
//                 </Button>
//               )}
//               {shouldShowModeSwitch && user?.role === 'artisan' && (
//                 <Button
//                   className={getArtisanSwitchButton().className}
//                   onClick={handleArtisanSwitch}
//                 >
//                   {getArtisanSwitchButton().icon}
//                   <span>{getArtisanSwitchButton().text}</span>
//                 </Button>
//               )}

//               {!user ? (
//                 <>
//                   <Link to="/login" className="btn-signin">
//                     <FaUser /> Log In
//                   </Link>
//                   <Link to="/register" className="btn-signin">
//                     <FaUser /> Sign Up
//                   </Link>
//                   <Link
//                     to="/artisan-join"
//                     className="btn-signin artisan-join-btn"
//                   >
//                     <FaPalette /> Join as an Artisan
//                   </Link>
//                 </>
//               ) : (
//                 <div className="custom-dropdown" ref={dropdownRef}>
//                   <button
//                     className="custom-dropdown-toggle"
//                     onClick={() => setDropdownOpen(!dropdownOpen)}
//                   >
//                     <span className="user-dropdown">
//                       <FaUser className="me-2" />
//                       <span className="user-name">
//                         {user.name?.split(' ')[0] || 'Account'}
//                       </span>
//                       <FaChevronDown
//                         className={`dropdown-arrow ${dropdownOpen ? 'open' : ''}`}
//                       />
//                     </span>
//                   </button>
//                   <div
//                     className={`custom-dropdown-menu ${dropdownOpen ? 'show' : ''}`}
//                   >
//                     {user?.role === 'artisan' && !artisanHasShopAccess && (
//                       <button
//                         onClick={() => {
//                           setDropdownOpen(false);
//                           setShowUpgradeModal(true);
//                         }}
//                         className="dropdown-item upgrade-item"
//                       >
//                         <FaUnlockAlt className="me-2" /> Unlock Ready-Made Shop
//                       </button>
//                     )}
//                     <button onClick={handleLogout} className="dropdown-item">
//                       Logout
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>

//             <div className="mobile-actions d-lg-none">
//               {!user ? (
//                 <div className="mobile-auth-buttons">
//                   <Link to="/login" className="btn-signin-mobile">
//                     <FaUser /> Log In
//                   </Link>
//                   <Link to="/register" className="btn-signup-mobile">
//                     <FaUser /> Sign Up
//                   </Link>
//                 </div>
//               ) : (
//                 <div className="mobile-user-section">
//                   <div className="mobile-user-info">
//                     <FaUser className="mobile-user-icon" />
//                     <span className="mobile-user-name">
//                       {user.name || 'User'}
//                     </span>
//                   </div>
//                   {user?.role === 'artisan' && !artisanHasShopAccess && (
//                     <button
//                       onClick={() => setShowUpgradeModal(true)}
//                       className="mobile-upgrade-btn"
//                     >
//                       <FaUnlockAlt /> Unlock Shop
//                     </button>
//                   )}
//                   <button onClick={handleLogout} className="mobile-logout-btn">
//                     Logout
//                   </button>
//                 </div>
//               )}
//             </div>
//           </Navbar.Collapse>
//         </Container>
//       </Navbar>

//       {/* Upgrade Modal with M-Pesa Payment */}
//       <Modal
//         show={showUpgradeModal}
//         onHide={handleCloseUpgradeModal}
//         centered
//         className="upgrade-modal"
//         backdrop="static"
//       >
//         <Modal.Header closeButton>
//           <h2>Unlock Ready-Made Shop</h2>
//         </Modal.Header>
//         <Modal.Body>
//           {paymentStep === 'info' && (
//             <div className="text-center">
//               <div className="upgrade-icon mb-3">
//                 <FaStore size={48} color="#673200" />
//               </div>
//               <h3 className="mb-3">Unlock Premium Features</h3>
//               <p className="text-muted mb-4">
//                 Start selling your finished furniture directly to customers!
//               </p>

//               <div className="features-list text-start mb-4">
//                 {[
//                   'List unlimited products',
//                   'Fixed pricing - no bidding',
//                   'Reach thousands of buyers',
//                   'Passive income 24/7',
//                   'Dedicated shop dashboard',
//                 ].map((feat, idx) => (
//                   <div key={idx} className="feature-item">
//                     <FaCheckCircle className="feature-check" />
//                     <span>{feat}</span>
//                   </div>
//                 ))}
//               </div>

//               <div className="pricing-card mb-4">
//                 <div className="price-label">Special Launch Price</div>
//                 <div className="price-amount">
//                   <span className="currency">KSh</span>
//                   <span className="amount">2,900</span>
//                   <span className="period">/month</span>
//                 </div>
//                 <div className="price-note">
//                   Cancel anytime • No hidden fees
//                 </div>
//               </div>

//               <button
//                 className="pay-with-mpesa-btn w-100"
//                 onClick={() => setPaymentStep('mpesa')}
//               >
//                 <img src={MpesaLogo} alt="M-Pesa" className="mpesa-icon" />
//                 Pay with M-Pesa
//               </button>
//             </div>
//           )}

//           {paymentStep === 'mpesa' && (
//             <div className="mpesa-payment-section">
//               <p className="text-muted text-center mb-4">
//                 Enter your M-Pesa registered phone number to receive payment
//                 prompt
//               </p>

//               <div className="form-group mb-4">
//                 <label className="form-label fw-bold">Phone Number</label>
//                 <input
//                   type="tel"
//                   className="form-control phone-input"
//                   value={mpesaPhone}
//                   onChange={(e) => setMpesaPhone(e.target.value)}
//                   placeholder="e.g., 0712345678"
//                   disabled={processingPayment}
//                 />
//                 <small className="text-muted">
//                   Enter the phone number registered with M-Pesa
//                 </small>
//               </div>

//               <div className="payment-steps bg-light p-3 rounded mb-4">
//                 <p className="fw-bold mb-2">How it works:</p>
//                 <ol className="ps-3 mb-0">
//                   <li>Enter your M-Pesa number</li>
//                   <li>Click "Pay Now"</li>
//                   <li>Check your phone for STK push</li>
//                   <li>Enter your PIN to complete payment</li>
//                   <li>Wait for confirmation</li>
//                 </ol>
//               </div>

//               <div className="d-flex gap-3">
//                 <button
//                   className="btn-back flex-grow-1"
//                   onClick={() => setPaymentStep('info')}
//                   disabled={processingPayment}
//                 >
//                   <FaArrowLeft className="me-2" /> Back
//                 </button>
//                 <button
//                   className="btn-pay flex-grow-1"
//                   onClick={handleMpesaPayment}
//                   disabled={processingPayment}
//                 >
//                   {processingPayment ? (
//                     <>
//                       <FaSpinner className="spinner me-2" /> Processing...
//                     </>
//                   ) : (
//                     'Pay KSh 2,900'
//                   )}
//                 </button>
//               </div>
//             </div>
//           )}

//           {paymentStep === 'processing' && (
//             <div className="text-center py-4">
//               <div className="processing-animation mb-4">
//                 <FaSpinner className="spinner-large" />
//               </div>
//               <h4>Processing Payment</h4>
//               <p className="text-muted mb-4">
//                 Please check your phone and enter your M-Pesa PIN to complete
//                 the payment
//               </p>
//               <div className="payment-instructions text-start bg-light p-3 rounded mb-4">
//                 <div className="instruction-step mb-2">
//                   <span className="step-number">1</span>
//                   <span>Check your phone for M-Pesa prompt</span>
//                 </div>
//                 <div className="instruction-step mb-2">
//                   <span className="step-number">2</span>
//                   <span>Enter your M-Pesa PIN</span>
//                 </div>
//                 <div className="instruction-step">
//                   <span className="step-number">3</span>
//                   <span>Wait for confirmation</span>
//                 </div>
//               </div>
//               <p className="waiting-text text-muted">
//                 Waiting for payment confirmation...
//               </p>
//             </div>
//           )}

//           {paymentStep === 'success' && (
//             <div className="text-center py-4">
//               <div className="success-icon mb-4">
//                 <FaCheckCircle size={64} color="#4CAF50" />
//               </div>
//               <h4>Payment Successful! 🎉</h4>
//               <p className="text-muted">
//                 Your account has been upgraded to premium!
//               </p>
//               <p className="redirect-text text-muted mt-3">
//                 Redirecting to your shop...
//               </p>
//             </div>
//           )}
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// }

import React, { useState, useEffect, useRef } from 'react';
import { Container, Nav, Navbar, Button } from 'react-bootstrap';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import {
  FaUser,
  FaPalette,
  FaStore,
  FaExchangeAlt,
  FaChevronDown,
  FaBars,
} from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import Logo from '../../assets/logo7.png';
import '../../styles/nav.scss';
import { toast } from 'react-toastify';

export default function FurnitureNavbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [currentMode, setCurrentMode] = useState('custom');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const dropdownRef = useRef(null);

  // Load user info
  useEffect(() => {
    const token = localStorage.getItem('access_token');
    const role = localStorage.getItem('role');
    const fullName = localStorage.getItem('full_name');
    const savedMode = localStorage.getItem('user_mode') || 'custom';

    if (token && role) {
      setUser({ role, name: fullName });
      setCurrentMode(savedMode);
    }
  }, [location.pathname]);

  // Detect current mode based on URL path
  useEffect(() => {
    if (
      location.pathname.includes('/artisan-dashboard') ||
      location.pathname.includes('/browse-project-requests') ||
      location.pathname.includes('/my-proposals') ||
      location.pathname.includes('/artisan-profile') ||
      location.pathname.includes('/my-projects') ||
      location.pathname.includes('/messaging')
    ) {
      setCurrentMode('custom');
    } else if (
      location.pathname.includes('/artisan-ready-products') ||
      location.pathname.includes('/artisan-product-management') ||
      location.pathname.includes('/artisan-orders') ||
      location.pathname.includes('/artisan-earnings')
    ) {
      setCurrentMode('shop');
    } else if (
      location.pathname.includes('/ready-made-products') ||
      location.pathname.includes('/cart')
    ) {
      setCurrentMode('shop');
    } else if (
      location.pathname.includes('/client-dashboard') ||
      location.pathname.includes('/projects') ||
      location.pathname.includes('/project-updates')
    ) {
      setCurrentMode('custom');
    }
  }, [location.pathname]);

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  // Client mode switching
  const handleClientSwitch = () => {
    const newMode = currentMode === 'custom' ? 'shop' : 'custom';
    localStorage.setItem('user_mode', newMode);
    setCurrentMode(newMode);

    if (newMode === 'custom') {
      navigate('/client-dashboard');
      toast.info('Switched to Custom Orders');
    } else {
      navigate('/ready-made-products');
      toast.info('Switched to Ready-Made Shop');
    }
  };

  // Artisan mode switching - FREE SWITCHING, NO LOCKS
  const handleArtisanSwitch = () => {
    const newMode = currentMode === 'custom' ? 'shop' : 'custom';
    localStorage.setItem('user_mode', newMode);
    setCurrentMode(newMode);

    if (newMode === 'custom') {
      navigate('/artisan-dashboard');
      toast.info('Switched to Custom Projects');
    } else {
      navigate('/artisan-ready-products');
      toast.info('Switched to Ready-Made Shop');
    }
  };

  // Logout
  const handleLogout = () => {
    localStorage.clear();
    setUser(null);
    navigate('/login');
    toast.success('Logout successful');
    setDropdownOpen(false);
  };

  // Show mode switch for logged-in artisans and clients
  const shouldShowModeSwitch =
    user && (user.role === 'client' || user.role === 'artisan');

  return (
    <>
      <Navbar
        expand="lg"
        className={`furniture-navbar ${scrolled ? 'scrolled' : ''}`}
        collapseOnSelect
      >
        <Container>
          {/* Logo */}
          <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
            <img src={Logo} alt="Artiza logo" className="logo" />
          </Navbar.Brand>

          {/* Mobile Right Section */}
          <div className="mobile-right-section d-flex d-lg-none align-items-center">
            {shouldShowModeSwitch && (
              <Button
                className="mode-switch-btn-mobile"
                onClick={user?.role === 'client' ? handleClientSwitch : handleArtisanSwitch}
                title={`Switch to ${currentMode === 'custom' ? 'Ready-Made Shop' : 'Custom Orders'}`}
              >
                <FaExchangeAlt />
              </Button>
            )}
            <Navbar.Toggle aria-controls="basic-navbar-nav">
              <FaBars />
            </Navbar.Toggle>
          </div>

          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mx-auto nav-links">
              {!user && (
                <>
                  <Nav.Link as={Link} to="/">
                    Home
                  </Nav.Link>
                  <Nav.Link as={Link} to="/about">
                    About
                  </Nav.Link>
                  <Nav.Link as={Link} to="/contact">
                    Contact
                  </Nav.Link>
                </>
              )}

              {/* Client - Custom Mode */}
              {user?.role === 'client' && currentMode === 'custom' && (
                <>
                  <Nav.Link as={Link} to="/client-dashboard">
                    Dashboard
                  </Nav.Link>
                  <Nav.Link as={Link} to="/projects">
                    My Projects
                  </Nav.Link>
                  <Nav.Link as={Link} to="/project-updates">
                    Project Progress
                  </Nav.Link>
                  <Nav.Link as={Link} to="/messages">
                    Messages
                  </Nav.Link>
                  <Nav.Link as={Link} to="/payments">
                    Payments
                  </Nav.Link>
                  <Nav.Link as={Link} to="/Profile">
                    Profile
                  </Nav.Link>
                </>
              )}

              {/* Client - Shop Mode */}
              {user?.role === 'client' && currentMode === 'shop' && (
                <>
                  <Nav.Link as={Link} to="/ready-made-products">
                    Shop
                  </Nav.Link>
                  <Nav.Link as={Link} to="/cart">
                    Cart
                  </Nav.Link>
                  <Nav.Link as={Link} to="/Profile">
                    Profile
                  </Nav.Link>
                </>
              )}

              {/* Artisan - Custom Mode */}
              {user?.role === 'artisan' && currentMode === 'custom' && (
                <>
                  <Nav.Link as={Link} to="/artisan-dashboard">
                    Dashboard
                  </Nav.Link>
                  <Nav.Link as={Link} to="/browse-project-requests">
                    Browse Projects
                  </Nav.Link>
                   <Nav.Link as={Link} to="/my-projects">
                    Ongoing Projects
                  </Nav.Link>
                  <Nav.Link as={Link} to="/my-proposals">
                    Sent Proposals
                  </Nav.Link>
                  <Nav.Link as={Link} to="/messaging">
                    Messages
                  </Nav.Link>
                 
                  <Nav.Link as={Link} to="/artisan-profile">
                    Profile
                  </Nav.Link>
                </>
              )}

              {/* Artisan - Shop Mode */}
              {user?.role === 'artisan' && currentMode === 'shop' && (
                <>
                  <Nav.Link as={Link} to="/artisan-ready-products">
                    My Products
                  </Nav.Link>
                  <Nav.Link as={Link} to="/artisan-product-management">
                    Add Product
                  </Nav.Link>
                  <Nav.Link as={Link} to="/artisan-orders">
                    Orders
                  </Nav.Link>
                  <Nav.Link as={Link} to="/artisan-earnings">
                    Earnings
                  </Nav.Link>
                  <Nav.Link as={Link} to="/artisan-profile">
                    Profile
                  </Nav.Link>
                </>
              )}

              {/* Admin */}
              {user?.role === 'admin' && (
                <>
                  <Nav.Link as={Link} to="/admin-dashboard">
                    Dashboard
                  </Nav.Link>
                  <Nav.Link as={Link} to="/users-management">
                    Users
                  </Nav.Link>
                  <Nav.Link as={Link} to="/projects-management">
                    Projects
                  </Nav.Link>
                  <Nav.Link as={Link} to="/flagged-messages">
                    Flagged
                  </Nav.Link>
                  <Nav.Link as={Link} to="/artisan-applications">
                    Artisan Applications
                  </Nav.Link>
                  <Nav.Link as={Link} to="/financials">
                    Financials
                  </Nav.Link>
                  <Nav.Link as={Link} to="/support">
                    Support
                  </Nav.Link>
                </>
              )}
            </Nav>

            {/* Desktop Actions - Mode Switch visible for logged-in users */}
            <div className="desktop-actions d-none d-lg-flex align-items-center">
              {shouldShowModeSwitch && (
                <Button
                  className="mode-switch-btn"
                  onClick={user?.role === 'client' ? handleClientSwitch : handleArtisanSwitch}
                >
                  <FaExchangeAlt className="me-2" />
                  <span>
                    {currentMode === 'custom' ? (
                      <>
                        Switch to <FaStore /> Shop
                      </>
                    ) : (
                      <>
                        Switch to <FaPalette /> Custom
                      </>
                    )}
                  </span>
                </Button>
              )}

              {!user ? (
                <>
                  <Link to="/login" className="btn-signin">
                    <FaUser /> Log In
                  </Link>
                  <Link to="/register" className="btn-signin">
                    <FaUser /> Sign Up
                  </Link>
                  <Link
                    to="/artisan-join"
                    className="btn-signin artisan-join-btn"
                  >
                    <FaPalette /> Join as an Artisan
                  </Link>
                </>
              ) : (
                <div className="custom-dropdown" ref={dropdownRef}>
                  <button
                    className="custom-dropdown-toggle"
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                  >
                    <span className="user-dropdown">
                      <FaUser className="me-2" />
                      <span className="user-name">
                        {user.name?.split(' ')[0] || 'Account'}
                      </span>
                      <FaChevronDown
                        className={`dropdown-arrow ${dropdownOpen ? 'open' : ''}`}
                      />
                    </span>
                  </button>
                  <div
                    className={`custom-dropdown-menu ${dropdownOpen ? 'show' : ''}`}
                  >
                    <button onClick={handleLogout} className="dropdown-item">
                      Logout
                    </button>
                  </div>
                </div>
              )}
            </div>

            <div className="mobile-actions d-lg-none">
              {!user ? (
                <div className="mobile-auth-buttons">
                  <Link to="/login" className="btn-signin-mobile">
                    <FaUser /> Log In
                  </Link>
                  <Link to="/register" className="btn-signup-mobile">
                    <FaUser /> Sign Up
                  </Link>
                </div>
              ) : (
                <div className="mobile-user-section">
                  <div className="mobile-user-info">
                    <FaUser className="mobile-user-icon" />
                    <span className="mobile-user-name">
                      {user.name || 'User'}
                    </span>
                  </div>
                  <button onClick={handleLogout} className="mobile-logout-btn">
                    Logout
                  </button>
                </div>
              )}
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}